// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__2pv6y","logo":"Layout_logo__OZu7f"};